import React from 'react';
import { useTheme } from '../ThemeContext';
import './ShinyText.css';

interface ShinyTextProps {
  text: string;
  disabled?: boolean;
  speed?: number;
  className?: string;
}

const ShinyText = ({ text, disabled = false, speed = 5, className = '' }: ShinyTextProps) => {
  const { theme } = useTheme();
  const animationDuration = `${speed}s`;
  const baseClass = theme === 'dark' ? 'shiny-text' : 'shiny-text-light';

  return (
    <div className={`${baseClass}${disabled ? ' disabled' : ''}${className ? ` ${className}` : ''}`} style={{ animationDuration }}>
      {text}
    </div>
  );
};

export default ShinyText;
